import { DraftBasketType, AddOrderAction } from '../types';

export const addOrderToBasket = (state: DraftBasketType, action: AddOrderAction): DraftBasketType => ({
  ...state,
  basket: [...state.basket, action.payload],
});
